import { render, staticRenderFns } from "./OrganisationSortList.vue?vue&type=template&id=24acac45&scoped=true&"
import script from "./OrganisationSortList.vue?vue&type=script&lang=js&"
export * from "./OrganisationSortList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSortList.vue?vue&type=style&index=0&id=24acac45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acac45",
  null
  
)

export default component.exports